module.exports = __webpack_public_path__ + "static/media/CC_NG_Referral_RO.5ce3119b.png";